export default {
  mounted() {
    let { meta } = this.$options
    if (meta) {
      meta = typeof meta === 'function' ? meta.call(this) : meta
      document
        .getElementsByName('description')[0]
        .setAttribute('content', `${meta}`)
    }
  },
}



// WEBPACK FOOTER //
// ./src/util/meta.js